import type { FC } from 'react';
import HomeV2Slider from './HomeV2Slider';
const HomeV2SliderContainer: FC = () => {
  return <HomeV2Slider data-sentry-element="HomeV2Slider" data-sentry-component="HomeV2SliderContainer" data-sentry-source-file="homeV2SliderContainer.tsx" />;
};
export default HomeV2SliderContainer;